<template>
  <div id="businesses-box">
    <vs-row>
      <vs-col ype="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
        <vs-card>
        <vs-row>
          <vs-col >
            <vs-button
              id="add-agency-form"
              icon="add"
              color="primary"
              @click="createBusiness()"
            >{{$t('Businesses.AddBusinessButton')}}</vs-button>
          </vs-col>
        </vs-row>
      </vs-card>
      </vs-col>
    </vs-row>
    <vs-row vs-justify="center">
      <vs-col vs-lg="12" vs-md="12" vs-sm="12" vs-xs="12">
        <div>
          <vs-card>
            <input type="search" class="search" placeholder="Recherche.." @keyup="filter" v-model="filter_data.keyword"/>

            <vs-table v-model="selected" :data="businesses">
              <template slot="thead">
                <vs-th>{{$t('Businesses.Table.Name')}}</vs-th>
                <vs-th>{{$t('Businesses.Table.Email')}}</vs-th>
                <vs-th>{{$t('Businesses.Table.Phone')}}</vs-th>
                <vs-th>{{$t('Businesses.Table.Address')}}</vs-th>
                <vs-th>{{$t('Businesses.Table.Options')}}</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].name">{{data[indextr].name}}</vs-td>

                  <vs-td :data="data[indextr].email">{{data[indextr].email}}</vs-td>

                  <vs-td :data="data[indextr].phone">
                    <span v-if="data[indextr].phone && data[indextr].phone!='0' && data[indextr].phone!='000000'">{{data[indextr].phone}}</span>
                    <span v-else>--</span>
                  </vs-td>

                  <vs-td
                    :data="data[indextr].address"
                  >{{data[indextr].address}},{{data[indextr].city}},{{data[indextr].country}}</vs-td>
                  <vs-td>
                    <div class="btn-alignment">
                      <vs-button
                        id="show-customer-button"
                        radius
                        color="success"
                        type="border"
                        icon="visibility"
                        @click="showBusiness(tr.id)"
                      ></vs-button>
                      <vs-button
                        id="edit-customer-button"
                        radius
                        color="warning"
                        type="border"
                        icon="edit"
                        @click="updateBusiness(tr.id)"
                      ></vs-button>
                      <!-- <vs-button
                        radius
                        color="dark"
                        type="border"
                        icon="lock"
                        @click="selected_business = tr.id;activePrompt = true"
                      ></vs-button> -->
                      <vs-button
                        radius
                        color="danger"
                        type="border"
                        icon="delete"
                        @click="deleteBusiness(data[indextr])"
                      ></vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-pagination :total="totalPages" @change="handleChangePage" v-model="currentPage"></vs-pagination>
          </vs-card>
        </div>
      </vs-col>


            <vs-prompt
                    color="primary"
                    @accept="changePassword"
                    :active.sync="activePrompt"
                    :title="$t('Profile.UpdatePasswordButton')"
                    :accept-text="$t('Profile.UpdatePasswordPrompt.ConfirmButton')"
                    :cancel-text="$t('Profile.UpdatePasswordPrompt.CancelButton')"
            >
              <div v-bar class="vs-scrollable">
                <div>
                  <div class="con-exemple-prompt px-4 py-3">
                    <vs-row>
                      <vs-col vs-w="12"><vs-input
                              :danger="errors.password"
                              :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.NewPassword')})"
                              :label="$t('Profile.NewPassword')"  type="password"  class="w-100 mb-2" 
                              v-model="neww.password"/></vs-col>
                    <vs-row>
                    </vs-row>
                      <vs-col vs-w="12"><vs-input
                             :danger="errors.password_confirm"
                             :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.PasswordConfirm')})"
                             :label="$t('Profile.PasswordConfirm')" type="password"  class="w-100 mb-2" 
                             v-model="neww.confirm_password"/></vs-col>
                    </vs-row>
                  </div>
                </div>
              </div>
            </vs-prompt>

      <!--V-Tour start-->
      <!-- <v-tour name="Businesses" :steps="steps">
        <template slot-scope="tour">
          <transition name="fade">
            <v-step
              v-if="tour.currentStep === index"
              v-for="(step, index) of tour.steps"
              :key="index"
              :step="step"
              :previous-step="tour.previousStep"
              :next-step="tour.nextStep"
              :stop="tour.stop"
              :is-first="tour.isFirst"
              :is-last="tour.isLast"
              :labels="tour.labels"
            >
              <template v-if="tour.currentStep === 0">
                <div slot="actions" class="v-step__buttons">
                  <button @click="goToNextPage" class="v-step__button">Next</button>
                </div>
              </template>
            </v-step>
          </transition>
        </template>
      </v-tour> -->
    </vs-row>
    
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import router from "../../_helpers/router";
import { businessService } from "../../_services";

export default {
  name: "Businesses",
  data: () => ({
    filter_data: {
      keyword: null
    },
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    maxItems: 0,
    selected: {},
    title: "Businesses",
    businesses: [],
    steps: [
      {
        target: "#businesses-listing", // We're using document.querySelector() under the hood
        params: {
          placement: "auto", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
    ],
    activePrompt: false,
    selected_business: null,
    errors:{
      password : false,
      password_confirm : false
    },
    neww:{
      password: null,
      confirm_password: null,
    }
  }),
  methods: {
    filter(){
        this.showLoading()
        businessService
          .filter(this.filter_data)
          .then((data) => {
            this.businesses = data.businesses.data;
            this.totalItems = data.businesses.total;
            this.maxItems = data.businesses.per_page;
            this.totalPages = data.businesses.last_page;
          })
          .finally(() => {
            this.hideLoading();
          });
    },
    createBusiness(){
      this.$router.push("/agencies/create");
    },
    showBusiness(tr) {
      this.$router.push("/agencies/" + tr + "/show");
    },
    updateBusiness(tr) {
      this.$router.push("/agencies/" + tr + "/update");
    },
    deleteBusiness(Business) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Customer.DeleteCustomerPrompt.Title"),
        text: this.$t("Customer.DeleteCustomerPrompt.Text", {
          name: Business.name
        }),
        acceptText: this.$t("Toasts.AcceptButton"),
        cancelText: this.$t("Toasts.CancelButton"),
        accept: function() {
          businessService
            .deleteBusiness(Business.id)
            .then(
              function(data) {
                this.handleChangePage(this.currentPage);
                this.notify(
                  this.$t("Toasts.Successful"),
                  this.$t("Customer.DeleteCustomerPrompt.ToastSuccessMessage"),
                  "success"
                );
              }.bind(this)
            )
            .catch(
              function() {
                this.notify(
                  this.$t("Toasts.Error"),
                  this.$t("Customer.DeleteCustomerPrompt.ToastFailMessage"),
                  "danger"
                );
              }.bind(this)
            )
            .finally(
              function() {
                this.hideLoading();
              }.bind(this)
            );
        }.bind(this)
      });
    },
    showLoading() {
      this.$vs.loading({
        container: "#businesses-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#businesses-box > div.con-vs-loading");
    },
    handleChangePage(page) {
      this.showLoading();
      businessService
        .getPage(page)
        .then((data) => {
          this.businesses = data.businesses.data;
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    ...mapActions("account", ["updateUserObject"]),
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    createdAt(date) {
      return this.$moment(date).fromNow();
    },
    goToNextPage() {
      router.push({ path: "/statistics?istour=on" });
    },
  },
  computed: {
    ...mapState({
      account_info: (state) => state.account.user.user,
      business_info: (state) => state.account.user.business,
    }),
  },
  mounted() {
   this.showLoading();
    businessService
      .getAll()
      .then((data) => {
        this.businesses = data.businesses.data;
        this.totalItems = data.businesses.total;
        this.maxItems = data.businesses.per_page;
        this.totalPages = data.businesses.last_page;
      })
      .finally(() => {
        this.hideLoading();
      });
      
    }
};
</script>

<style scoped>
  .search{
    height: 35px;
    border: 1px solid #aaa;
    border-radius: 5px;
    float: right;
    width: 320px;
    padding: 0 10px;
  }
</style>